// @ts-nocheck
/* eslint-disable */
import { node, icon } from "~/util/dom";
import { CONFIG } from "~/config";
import ContentOverlay from "~/content.overlay";
import { _ } from "~/i18n";

/**
 * Overlay pres cely sloupec, pouzivany k zobrazeni v sirce 2
 */
export default class ContentFull extends ContentOverlay {
	activate() {
		if (this.isActive()) { return this; }

		if (Mapy.active[0] instanceof ContentFull) { Mapy.active[0].deactivate(); }

		return super.activate();
	}

	handleEvent(e) {
		if (CONFIG.inFrame) {
			return;
		}

		switch (e.type) {
			case "keydown":
				if (e.keyCode == 27) {
					this._clickClose();
				}
			break;

			case "click":
				if (this._dom.fullscreenButton && this._dom.fullscreenButton.contains(e.target)) {
					document.fullscreenElement ? document.exitFullscreen() : Mapy.getComponent("layout").getContent().requestFullscreen();
				}
			break;

			case "fullscreenchange":
				this._changeFullscreen();
			break;
		}
	}

	show() {
		Mapy.getComponent("layout").setWidth(2);
		document.body.classList.add("content-full");
		window.addEventListener("keydown", this, false);
		if (this._dom.fullscreenButton) { this._dom.fullscreenButton.addEventListener("click", this, false); }
		document.addEventListener("fullscreenchange", this, false);
		return super.show();
	}

	hide() {
		document.body.classList.remove("content-full");
		window.removeEventListener("keydown", this, false);
		if (this._dom.fullscreenButton) { this._dom.fullscreenButton.removeEventListener("click", this, false); }
		document.removeEventListener("fullscreenchange", this, false);
		return super.hide();
	}

	_buildCloseButton() {
		super._buildCloseButton();
		this._dom.closeButton.className = "close-overlay noprint";
		this._dom.closeButton.innerHTML = _("close");
	}

	_appendCloseButton() {
		if (!CONFIG.inFrame) {
			var node = Mapy.getComponent("layout").getScrollNode();
			node.parentNode.insertBefore(this._dom.closeButton, node);
		}
	}

	_clickClose(e, elm) {
		if (document.fullscreenElement) { document.exitFullscreen(); }
		Mapy.getComponent("layout").setWidth(1);
		Mapy.getComponent("history").save();
	}

	_buildFullscreenButton() {
		this._dom.fullscreenButton = node("button", { className: "fullscreen noprint" });
		this._dom.fullscreenButton.append(
			icon("fullscreen"),
		);
	}

	_changeFullscreen() {
		this._dom.fullscreenButton.classList[document.fullscreenElement ? "add" : "remove"]("close");
		if (document.fullscreenElement) { this._removeCloseButton(); }
		else { this._appendCloseButton(); }
	}

	_syncPort() {
		if (!this.isActive()) { return; }
		var pos = JAK.DOM.getPortBoxPosition(this._dom.container);
		this._dom.container.style.height = (JAK.DOM.getDocSize().height - pos.top)+ "px";
	}
};
